export default "__VITE_ASSET__5bb06954__"